import React, { useState, useRef, useEffect } from "react";
import {
  Grid,
  Typography,
  Divider,
  Popper,
  Paper,
  Stack,
  Avatar,
  List,
  ListItem,
  ListItemText,
  Autocomplete,
  TextField,
  ListItemIcon,
  Switch,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Styles from "../TaskDetails.module.scss";
import { ISSUETYPE, PRIORITY, STATUS } from "../../../common/constant/constant";
import bug from "../../../assets/images/bug.png";
import Task_Icon from "../../../assets/images/Task_Icon.svg";
import Meeting_Icon from "../../../assets/images/Meeting.png";
import Extra_Icon from "../../../assets/images/Extra_Icon.svg";
import Testing_Icon from "../../../assets/images/Testing_Icon.svg";
import Designing_Icon from "../../../assets/images/Designing_Icon.svg";
import Deployment_Icon from "../../../assets/images/Deployment_Icon.svg";
import { IoFlagOutline } from "react-icons/io5";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 35,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: "0px",
    margin: 1,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(15px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#008080",
        opacity: 1,
        border: 0,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 18,
    height: 18,
  },
  "& .MuiSwitch-track": {
    borderRadius: 25 / 2,
    backgroundColor: "#676767",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const getPriorityColor = (priorityValue) => {
  const priorityMap = {
    [PRIORITY.HIGH]: "#D50707",
    [PRIORITY.MEDIUM]: "#D7BB21",
    [PRIORITY.LOW]: "#21A600",
  };
  return priorityMap[priorityValue] || "#21A600";
};

const DetailsPanel = (props) => {
  const {
    selectedData,
    fromClient,
    userData,
    parentTasks,
    onAssignedToChange,
    onParentTaskChange,
    onPriorityChange,
    onVerifyStatusChange,
    onClientVerifyStatusChange,
    onTypeChange,
    onStatusChange,
    onSwitchChange,
    onClientChange,
    onSetEstimated,
    statusOption,
    priorityOption,
    typeOption,
    QAVerifyOption,
    clientVerifyOption,
    getCurrentStatusLabel,
    getCurrentPriorityLabel,
    getCurrentIssueTypeLabel,
    getCurrentVerifyStatusLabel,
    getParentTaskName,
    onActualDeadlineDateChange,
    onClientDeadlineDateChange,
  } = props;

  const [openPropper, setOpenPropper] = useState(false);
  const [openPriorityPropper, setOpenPriorityPropper] = useState(false);
  const [openTypePropper, setOpenTypePropper] = useState(false);
  console.log(openPriorityPropper, openTypePropper);
  const [openParentTaskPropper, setOpenParentTaskPropper] = useState(false);
  const [estimatedTime, setEstimatedTime] = useState(
    selectedData?.estimatedTime || ""
  );

  const anchorRef = useRef(null);
  const anchorRef4 = useRef(null);

  useEffect(() => {
    setEstimatedTime(selectedData?.estimatedTime || "");
  }, [selectedData?.estimatedTime]);

  const openPopper = () => setOpenPropper(true);
  const closePopper = () => setOpenPropper(false);
  const openPriorityPopper = () => setOpenPriorityPropper(true);
  const closePriorityPopper = () => setOpenPriorityPropper(false);
  const openTypePopper = () => setOpenTypePropper(true);
  const closeTypePopper = () => setOpenTypePropper(false);
  const openParentTaskPopper = () => setOpenParentTaskPropper(true);
  const closeParentTaskPopper = () => setOpenParentTaskPropper(false);

  const handleInputChange = (event) => {
    const value = event.target.value.replace(" H", "");
    if (/^[0-9]*$/.test(value)) {
      setEstimatedTime(value);
    }
  };
  // Helper logic for conditional visibility
  const isStandardTask =
    selectedData?.issueType === ISSUETYPE.TASK ||
    selectedData?.issueType === ISSUETYPE.BUG;

  // Parent Task is visible for Task, Bug, and Designing
  const showParentTask =
    isStandardTask || selectedData?.issueType === ISSUETYPE.DESIGNING;


  return (

    <Grid
      sx={{
        padding: 1,
        background: "#FFFFFF",
        border: "1px solid #E4E4E7",
        borderRadius: "5px",
        overflow: "visible",
      }}
    >
      <Typography
        sx={{ fontWeight: 600, fontSize: "16px", padding: "10px 20px" }}
      >
        Details
      </Typography>
      <Divider sx={{ opacity: 1, color: "#E4E4E7" }} />

      {!fromClient && (
        <>
          {/* Parent Task Section */}

          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Project Name
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#4E4E4E",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                ref={anchorRef4}
              >
                {selectedData?.projectName}
              </Typography>
            </Grid>
          </Grid>
          {/* Task No Section */}
          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Task No
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#4E4E4E",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                ref={anchorRef4}
              >
                {selectedData?.taskNo}
              </Typography>
            </Grid>
          </Grid>
          {/* Assignee Section */}
          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Assignee
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                gap={1}
                paddingRight={"10px"}
                onClick={openPopper}
                sx={{ cursor: "pointer" }}
                ref={anchorRef}
              >
                <Avatar
                  src={selectedData?.assignedToProfile}
                  sx={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    fontSize: "14px",
                    fontWeight: 600,
                    backgroundColor: "#C7EEEF",
                    color: "#055253",
                  }}
                >
                  {selectedData?.assignedToName === null
                    ? null
                    : selectedData?.assignedToName?.charAt(0).toUpperCase()}
                </Avatar>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#4E4E4E",
                    fontWeight: 500,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {selectedData?.assignedToName === null
                    ? "Unassigned"
                    : selectedData?.assignedToName}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
          <Popper
            open={openPropper}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            sx={{
              backgroundColor: "fff",
              overflow: "auto",
              boxShadow: "5px 5px 20px rgb(248, 248, 248) !important",
              zIndex: 1300,
            }}
          >
            <Paper
              sx={{
                border: "1px solid rgb(238, 238, 238)",
                height: "200px",
                overflow: "auto",
                background: "fff",
                width: "170px",
                maxWidth: "170px",
              }}
            >
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                sx={{
                  padding: 0.5,
                  position: "sticky",
                  top: 0,
                  background: "#FFFFFF",
                  zIndex: 1,
                }}
              >
                <Typography>Employee</Typography>
                <Grid direction={"row"} className={Styles.DeleteClose_Icon}>
                  <CloseIcon
                    sx={{ width: "20px", height: "20px" }}
                    onClick={closePopper}
                  />
                </Grid>
              </Stack>
              <Divider
                sx={{
                  alignItems: "flex-end",
                  position: "sticky",
                  top: "16%",
                  background: "#FFFFFF",
                  zIndex: 1,
                  opacity: 1,
                }}
              />
              <List sx={{ padding: 0 }}>
                {userData.map((user) => (
                  <ListItem
                    key={user._id}
                    button
                    onClick={(event) => onAssignedToChange(event, user)}
                    sx={{
                      height: "40px",
                      padding: 1,
                      "&:hover": {
                        backgroundColor: "#e8fcfc",
                      },
                    }}
                  >
                    <ListItemText primary={user.name} />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Popper>

          {/* Parent Task Section - Conditional Visibility */}
          {showParentTask && (
            <>
              <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
                <Grid item xs={6}>
                  <Typography
                    style={{
                      color: "#45546E",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    Parent Task
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#4E4E4E",
                      fontWeight: 500,
                      maxWidth: "150px",
                      cursor: "pointer",
                      wordBreak: "break-all",
                    }}
                    onClick={openParentTaskPopper}
                    ref={anchorRef4}
                  >
                    {getParentTaskName(selectedData?.parentTask)}
                  </Typography>
                </Grid>
              </Grid>
              <Popper
                open={openParentTaskPropper}
                anchorEl={anchorRef4.current}
                placement="bottom-start"
                sx={{
                  backgroundColor: "fff",
                  overflow: "auto",
                  boxShadow: "5px 5px 20px rgb(248, 248, 248) !important",
                  zIndex: 1300,
                }}
              >
                <Paper
                  sx={{
                    border: "1px solid rgb(238, 238, 238)",
                    height: "200px",
                    overflow: "auto",
                    background: "fff",
                    width: "300px",
                    maxWidth: "300px",
                  }}
                >
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    sx={{
                      padding: 0.5,
                      position: "sticky",
                      top: 0,
                      background: "#FFFFFF",
                      zIndex: 1,
                    }}
                  >
                    <Typography>Parent Tasks</Typography>
                    <Grid direction={"row"} className={Styles.DeleteClose_Icon}>
                      <CloseIcon
                        sx={{ width: "20px", height: "20px" }}
                        onClick={closeParentTaskPopper}
                      />
                    </Grid>
                  </Stack>
                  <Divider
                    sx={{
                      alignItems: "flex-end",
                      position: "sticky",
                      top: "16%",
                      background: "#FFFFFF",
                      zIndex: 1,
                      opacity: 1,
                    }}
                  />
                  <List sx={{ padding: 0 }}>
                    {parentTasks.map((task) => (
                      <ListItem
                        key={task._id}
                        button
                        onClick={(event) => onParentTaskChange(event, task)}
                        sx={{
                          minHeight: "40px",
                          padding: 1,
                          "&:hover": {
                            backgroundColor: "#e8fcfc",
                          },
                        }}
                      >
                        <ListItemText
                          primary={task.label}
                          primaryTypographyProps={{
                            style: {
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              fontSize: "14px"
                            }
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </Popper>
            </>
          )}

          {/* Actual Deadline Date Section */}
          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Actual Deadline
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                type="date"
                value={
                  selectedData?.deadLineDate
                    ? new Date(selectedData.deadLineDate)
                      .toISOString()
                      .split("T")[0]
                    : ""
                }
                onChange={onActualDeadlineDateChange}
                disabled={fromClient}
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                }}
                inputProps={{
                  min: new Date().toISOString().split("T")[0] // Move min here
                }}
              />
            </Grid>
          </Grid>
          {/* Estimated Time Section */}
          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Estimated time
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={estimatedTime ? `${estimatedTime}` : ""}
                onChange={handleInputChange}
                onBlur={() => onSetEstimated(estimatedTime)}
                variant="standard"
                placeholder="Enter Hour"
                disabled={fromClient}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </Grid>
          </Grid>

          {/* Hold Switch */}
          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Hold
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <IOSSwitch
                checked={selectedData?.isHold || false}
                onChange={onSwitchChange}
              />
            </Grid>
          </Grid>

          {/* View cliend */}
          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Client View
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <IOSSwitch
                checked={selectedData?.isclientView || false}
                onChange={onClientChange}
              />
            </Grid>
          </Grid>
        </>
      )}

      {/* Status Section - Conditional Visibility */}
      {isStandardTask && (
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          justifyContent={"space-between"}
          mt={2}
          ml={0}
        >
          <Grid item xs={6}>
            <Typography
              style={{
                color: "#45546E",
                fontWeight: "500",
                fontSize: "16px",
              }}
            >
              Status
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Autocomplete
              options={statusOption}
              getOptionLabel={(option) => option.label}
              value={statusOption.find(
                (option) => option.label === getCurrentStatusLabel()
              )}
              onChange={onStatusChange}
              disableClearable
              disabled={fromClient}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // variant="standard"
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                  }}
                />
              )}
              sx={{
                marginRight: "15px !important",
                "& .MuiAutocomplete-inputRoot": {
                  padding: "0px !important",
                  borderRadius: "4px !important",
                },
              }}
            />
          </Grid>
        </Grid>
      )}

      {/* Priority Section - Conditional Visibility */}
      {isStandardTask && (
        <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
          <Grid item xs={6}>
            <Typography
              style={{
                color: "#45546E",
                fontWeight: "500",
                fontSize: "16px",
              }}
            >
              Priority
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Grid container alignItems={"center"}>
              <Grid item xs={2}>
                <IoFlagOutline
                  size={16}
                  color={getPriorityColor(selectedData.priority)}
                />
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  options={priorityOption}
                  getOptionLabel={(option) => option.label}
                  value={priorityOption.find(
                    (option) => option.label === getCurrentPriorityLabel()
                  )}
                  onChange={onPriorityChange}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                      }}
                    />
                  )}
                  sx={{
                    marginRight: "15px !important",
                    "& .MuiAutocomplete-inputRoot": {
                      padding: "0px !important",
                      borderRadius: "4px !important",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Task Type Section */}
      <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
        <Grid item xs={6}>
          <Typography
            style={{
              color: "#45546E",
              fontWeight: "500",
              fontSize: "16px",
            }}
          >
            Task Type
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Grid container alignItems={"center"}>
            <Grid item xs={2}>
              {selectedData.issueType === ISSUETYPE.BUG ? (
                <img src={bug} style={{ width: "20px", height: "20px" }} alt="Bug" />
              ) : selectedData.issueType === ISSUETYPE.MEETING ? (
                <img
                  src={Meeting_Icon}
                  style={{ width: "20px", height: "20px" }}
                  alt="Meeting"
                />
              ) : selectedData.issueType === ISSUETYPE.TESTING ? (
                <img
                  src={Testing_Icon}
                  style={{ width: "20px", height: "20px" }}
                  alt="Testing"
                />
              ) : selectedData.issueType === ISSUETYPE.DESIGNING ? (
                <img
                  src={Designing_Icon}
                  style={{ width: "20px", height: "20px" }}
                  alt="Designing"
                />
              ) : selectedData.issueType === ISSUETYPE.OTHERS ? (
                <img
                  src={Extra_Icon}
                  style={{ width: "20px", height: "20px" }}
                  alt="Others"
                />
              ) : selectedData.issueType === ISSUETYPE.DEPLOYMENT ? (
                <img
                  src={Deployment_Icon}
                  style={{ width: "20px", height: "20px" }}
                  alt="Deployment"
                />
              ) : (
                <img
                  src={Task_Icon}
                  style={{ width: "20px", height: "20px" }}
                  alt="Task"
                />
              )}
            </Grid>
            <Grid item xs={10}>
              <Autocomplete
                options={typeOption}
                getOptionLabel={(option) => option.label}
                value={typeOption.find(
                  (option) => option.label === getCurrentIssueTypeLabel()
                )}
                onChange={onTypeChange}
                disabled={fromClient || !isStandardTask}
                disableClearable
                componentsProps={{
                  popper: {
                    sx: { zIndex: 9999 },
                    placement: 'left-start',
                  },
                  paper: {
                    sx: {
                      maxHeight: 250,
                      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                      minWidth: 150,
                    },
                  },
                }}
                ListboxProps={{
                  sx: { maxHeight: 250 },
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props} sx={{ gap: 1 }}>
                    <ListItemIcon sx={{ minWidth: 28 }}>{option.icon}</ListItemIcon>
                    <ListItemText primary={option.label} />
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                    }}
                  />
                )}
                sx={{
                  marginRight: "15px !important",
                  "& .MuiAutocomplete-inputRoot": {
                    padding: "0px !important",
                    borderRadius: "4px !important",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Client Deadline Date Section */}
      <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
        <Grid item xs={6}>
          <Typography
            style={{
              color: "#45546E",
              fontWeight: "500",
              fontSize: "16px",
            }}
          >
            {fromClient ? "Deadline" : "Client Deadline"}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="date"
            value={
              selectedData?.clientDeadlineDate
                ? new Date(selectedData.clientDeadlineDate).toLocaleDateString(
                  "en-CA"
                )
                : ""
            }
            onChange={onClientDeadlineDateChange}
            disabled={!fromClient}
            variant="standard"
            InputProps={{
              disableUnderline: true,
              inputProps: {
                min: selectedData?.clientDeadlineDate
                  ? new Date(
                    selectedData.clientDeadlineDate
                  ).toLocaleDateString("en-CA")
                  : undefined,
              },
            }}
          />
        </Grid>
      </Grid>

      {/* Verify Status Section */}
      {((selectedData?.status === STATUS.QA && fromClient === false) ||
        selectedData?.status === STATUS.PRODUCTION) && (
          <Grid container spacing={2} alignItems={"center"} mt={2} ml={0}>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "#45546E",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Verify Status
              </Typography>
            </Grid>
            <Grid item xs={6}>
              {selectedData?.clientVerified ? (
                <Typography
                  style={{
                    color: "#45546E",
                    fontSize: "16px",
                  }}
                >
                  Completed
                </Typography>
              ) : (
                <Autocomplete
                  options={fromClient == true ? clientVerifyOption : QAVerifyOption}
                  getOptionLabel={(option) => option.label}
                  disableClearable={true}
                  value={clientVerifyOption.find(
                    (option) => option.label === getCurrentVerifyStatusLabel()
                  )}
                  onChange={
                    fromClient == true
                      ? onClientVerifyStatusChange
                      : onVerifyStatusChange
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                      }}
                    />
                  )}
                  sx={{
                    "& .MuiAutocomplete-inputRoot": {
                      padding: "0px",
                    },
                  }}
                />
              )}
            </Grid>
          </Grid>
        )}
    </Grid>
  );
};

export default DetailsPanel;
